const PIN_KEY_PREFIX = "freshpaint:pinDestinationConfigTab:";

// During first-time destination setup we want the detail page to stay on the
// Configuration tab (rather than defaulting to Event monitoring) so the user
// can finish the remaining steps — allowlists, connection mode, etc. Some setup
// flows (OAuth redirects, the GA4 wizard) navigate or fully reload before the
// tab state can be held in memory, so we persist the intent in sessionStorage
// keyed by destination id and consume it once the detail page reads it.
export function pinConfigurationTab(destinationId?: string): void {
  if (!destinationId) return;
  try {
    sessionStorage.setItem(PIN_KEY_PREFIX + destinationId, "1");
  } catch {
    // sessionStorage can be unavailable (private mode, blocked storage).
    // Pinning is a nice-to-have, so failing to persist it is acceptable.
  }
}

export function consumeConfigurationTabPin(destinationId?: string): boolean {
  if (!destinationId) return false;
  try {
    const key = PIN_KEY_PREFIX + destinationId;
    const pinned = sessionStorage.getItem(key) === "1";
    if (pinned) {
      sessionStorage.removeItem(key);
    }
    return pinned;
  } catch {
    return false;
  }
}
